<div class="bg-platinum text-white py-16 sm:py-20">
  <div class="mx-auto max-w-5xl px-5">
    <div class="mx-auto max-w-4xl text-center mb-12">
      <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        CFB 2024 <span class="text-turquoise">Season Results</span>
      </h2>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      
      <div class="flex flex-col gap-4 justify-between">
        <div class="bg-turquoise/10 rounded-xl p-6 flex-1 card-hover-effect">
          <div class="flex items-center justify-between">
            <h3 class="font-semibold text-xl">Best weeks</h3>
          </div>
          <div class="mt-4">
            <div *ngFor="let week of bestWeeks" class="flex items-center justify-between text-sm py-4 border-b border-gray-600/40">
              <div class="flex items-center gap-x-2">
                <img src="https://imgix.cosmicjs.com/c52f6eb0-5a7c-11f0-ae5a-0f56aa053fcd-crown.svg" alt="Crown Icon" class="h-5 w-5" width="20" height="20">
                <span>{{ week.week }}</span>
              </div>
              <span class="font-mono">{{ week.record }}</span>
            </div>
          </div>
        </div>
        <div class="bg-turquoise/10 rounded-xl p-6 flex-1 card-hover-effect">
        <div class="flex items-center justify-between">
            <h3 class="font-semibold text-xl">Units</h3>
            <img src="https://imgix.cosmicjs.com/2d20d170-5a7e-11f0-ae5a-0f56aa053fcd-dollar-sign-1.svg" alt="Dollar Sign Icon" class="h-6 w-6" width="24" height="24">
        </div>
          <p class="mt-2 text-3xl font-semibold text-green-400">+42.06</p>
          <p class="mt-4 text-lg text-gray-300">$4,206 profit for $100 bettor</p>
        </div>
      </div>
      
      <div class="flex flex-col gap-4 justify-between">
        <div class="bg-turquoise/10 rounded-xl p-6 flex-1 card-hover-effect">
          <div class="flex justify-between items-center">
            <h3 class="font-semibold text-xl">Wins</h3>
            <img src="https://imgix.cosmicjs.com/2d260190-5a7e-11f0-ae5a-0f56aa053fcd-shield-check.svg" alt="Shield Check Icon" class="h-6 w-6" width="24" height="24">
          </div>
          <p class="text-5xl font-bold mt-2">105</p>
        </div>
        <div class="bg-turquoise/10 rounded-xl p-6 flex-1 card-hover-effect">
            <div class="flex justify-between items-center">
                <h3 class="font-semibold text-xl">Losses</h3>
                <img src="https://imgix.cosmicjs.com/2d24c910-5a7e-11f0-ae5a-0f56aa053fcd-shield-x.svg" alt="Shield X Icon" class="h-6 w-6" width="24" height="24">
            </div>
            <p class="text-5xl font-bold mt-2">46</p>
        </div>
        <div class="bg-turquoise/10 rounded-xl p-6 flex-1 card-hover-effect">
            <div class="flex justify-between items-center">
                <h3 class="font-semibold text-xl">Pushes/Voids</h3>
                <img src="https://imgix.cosmicjs.com/2d242cd0-5a7e-11f0-ae5a-0f56aa053fcd-shield-minus.svg" alt="Shield Minus Icon" class="h-6 w-6" width="24" height="24">
            </div>
            <p class="text-5xl font-bold mt-2">2</p>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div class="bg-turquoise/10 rounded-xl p-6 flex-1 card-hover-effect flex flex-col items-center">
            <h3 class="font-semibold text-xl">ROI</h3>
            <p class="text-4xl font-bold text-green-400 mt-2">+28.38%</p>
            <div class="flex-1 flex items-center justify-center mt-4">
                <img src="https://imgix.cosmicjs.com/2d258c60-5a7e-11f0-ae5a-0f56aa053fcd-line-chart.svg" alt="Line Chart Icon"
                    class="h-24 w-24" width="96" height="96">
            </div>
        </div>
        <div class="bg-turquoise/10 rounded-xl p-6 flex-1 flex flex-col card-hover-effect items-center">
          <h3 class="font-semibold text-xl">Strike rate</h3>
          <p class="text-4xl font-bold mt-2">69%</p>
        <div class="flex-1 flex items-center justify-center mt-4">
            <img src="https://imgix.cosmicjs.com/2d234270-5a7e-11f0-ae5a-0f56aa053fcd-locate-fixed.svg" alt="Locate Fixed Icon"
                class="h-24 w-24" width="96" height="96">
        </div>
        </div>
      </div>

      <!-- <div class="md:col-span-2 lg:col-span-2 bg-turquoise/10 rounded-xl p-6">
        <h3 class="font-semibold">Top 5 Most Picked Teams and Their Records</h3>
        <div class="mt-4">
        <div class="flex justify-between text-xs text-gray-400 pb-2 border-b border-white/10">
            <div class="w-1/2 flex items-center gap-x-1">Team
                <svg class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M10 5a.75.75 0 01.75.75v6.638l1.97-1.97a.75.75 0 111.06 1.06l-3.25 3.25a.75.75 0 01-1.06 0L6.22 11.47a.75.75 0 111.06-1.06l1.97 1.97V5.75A.75.75 0 0110 5z"
                        clip-rule="evenodd" />
                </svg>
            </div>
            <div class="w-1/4 text-right flex items-center justify-end gap-x-1">Record 
                <svg class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M10 5a.75.75 0 01.75.75v6.638l1.97-1.97a.75.75 0 111.06 1.06l-3.25 3.25a.75.75 0 01-1.06 0L6.22 11.47a.75.75 0 111.06-1.06l1.97 1.97V5.75A.75.75 0 0110 5z"
                        clip-rule="evenodd" />
                </svg>
            </div>
        </div>
          <div class="mt-2 space-y-2">
            <div *ngFor="let team of topPickedTeams" class="flex justify-between items-center bg-gray-900/30 p-2 rounded-md">
              <div class="w-1/2 flex items-center gap-x-3">
                <img [src]="team.logoUrl" alt="{{team.name}} logo" class="h-6 w-6">
                <span class="text-sm font-medium">{{ team.name }}</span>
                <span *ngIf="team.isMostPicked"
                    class="text-xs text-green-400 bg-green-500/10 px-2 py-0.5 rounded-full flex items-center gap-x-1">
                    <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                            clip-rule="evenodd" />
                    </svg>
                    Most Picked
                </span>
              </div>
              <div class="w-1/2 text-right text-sm text-gray-300">{{ team.picks }}, {{ team.record }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-2 lg:col-span-1 bg-turquoise/10 rounded-xl p-6">
        <h3 class="font-semibold">Most Common Lines</h3>
         <div class="mt-4">
        <div class="flex justify-between text-xs text-gray-400 pb-2 border-b border-white/10">
            <div class="w-1/2 flex items-center gap-x-1">Spread
                <svg class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M10 5a.75.75 0 01.75.75v6.638l1.97-1.97a.75.75 0 111.06 1.06l-3.25 3.25a.75.75 0 01-1.06 0L6.22 11.47a.75.75 0 111.06-1.06l1.97 1.97V5.75A.75.75 0 0110 5z"
                        clip-rule="evenodd" />
                </svg>
            </div>
            <div class="w-1/2 text-right flex items-center justify-end gap-x-1">Occurrences 
                <svg class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M10 5a.75.75 0 01.75.75v6.638l1.97-1.97a.75.75 0 111.06 1.06l-3.25 3.25a.75.75 0 01-1.06 0L6.22 11.47a.75.75 0 111.06-1.06l1.97 1.97V5.75A.75.75 0 0110 5z"
                        clip-rule="evenodd" />
                </svg>
            </div>
        </div>
          <div class="mt-2 space-y-2">
            <div *ngFor="let line of mostCommonLines" class="flex justify-between items-center p-2">
              <div class="w-1/2 text-sm font-medium">{{ line.spread }}</div>
              <div class="w-1/2 text-right text-sm text-gray-300">{{ line.occurrences }}</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

  </div>
</div>